import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';

/**
 * @param {Task}                        confirmTicketDeletionModalTask   Required - Task that controls the modal
 */
let ConfirmCategoryDeleteModalComponent = (_class = class ConfirmCategoryDeleteModalComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onSubmitTask", _buildTask(() => ({
      context: this,
      generator: function* (e) {
        e.preventDefault();
        const {
          confirmTicketDeletionModalTask
        } = this.args;
        const confirmTask = confirmTicketDeletionModalTask.last;
        yield confirmTask?.continue();
      }
    }), {
      drop: true
    }, "onSubmitTask", null));
  }
  onCancel() {
    const {
      confirmTicketDeletionModalTask
    } = this.args;
    const confirmTask = confirmTicketDeletionModalTask.last;
    confirmTask?.abort();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onCancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCancel"), _class.prototype)), _class);
export { ConfirmCategoryDeleteModalComponent as default };